function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useCallback, useEffect, useRef, useState } from 'react';
import { catchError, forkJoin, interval, map, of, switchMap } from 'rxjs';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { gtmEvents, MfeTypes } from '../enums';
import { getAppBuildData } from '../util';
import { useLoadMfePaths } from './use-load-mfe-paths';
import { useAppService } from './use-services';
import { useSubscriptionRef } from './use-subscription-ref';
var appBuildDataChannel = new BroadcastChannel('app-build-data-delta');
var AppBuildDataChannelEvent = /*#__PURE__*/ function(AppBuildDataChannelEvent) {
    AppBuildDataChannelEvent[AppBuildDataChannelEvent["CHECK_STREAMING"] = 0] = "CHECK_STREAMING";
    AppBuildDataChannelEvent[AppBuildDataChannelEvent["SHARE_STREAMING"] = 1] = "SHARE_STREAMING";
    AppBuildDataChannelEvent[AppBuildDataChannelEvent["SHIFT_STREAMING"] = 2] = "SHIFT_STREAMING";
    AppBuildDataChannelEvent[AppBuildDataChannelEvent["LEAVE_STREAMING"] = 3] = "LEAVE_STREAMING";
    AppBuildDataChannelEvent[AppBuildDataChannelEvent["NEW_BUILD"] = 4] = "NEW_BUILD";
    return AppBuildDataChannelEvent;
}(AppBuildDataChannelEvent || {});
var intervalTime = 5 * 60 * 1000;
var allMfeTypes = Object.values(MfeTypes);
export var useAppReloadRequired = function() {
    var sendDataToGTM = useGTMDispatch();
    var appService = useAppService();
    var mfeEnabledPaths = useLoadMfePaths(allMfeTypes);
    var _useState = _sliced_to_array(useState(false), 2), isReloadRequired = _useState[0], setIsReloadRequired = _useState[1];
    var isStreamingRef = useRef(false);
    var isOtherStreamingRef = useRef(false);
    var joinedStreamListRef = useRef();
    var enabledPathListRef = useRef([]);
    var appSessionIdRef = useRef(Math.random().toString(36).slice(2));
    var deltaStreamRef = useSubscriptionRef();
    var trackCallError = useCallback(function(appKey) {
        sendDataToGTM({
            eventName: gtmEvents.CallingNewBuildNumberApi,
            message: "".concat(appKey, " error in calling build number from app-metadata")
        });
    }, [
        sendDataToGTM
    ]);
    var handleNewBuildEvent = useCallback(function(buildDataList) {
        if (isReloadRequired) {
            return;
        }
        var buildMap = getAppBuildData();
        var newBuildExists = buildDataList.some(function(data) {
            var currentBuildId = data.appKey ? buildMap[data.appKey] : null;
            return currentBuildId && data.buildId && currentBuildId !== data.buildId;
        });
        if (newBuildExists) {
            setIsReloadRequired(true);
        }
    }, [
        isReloadRequired
    ]);
    var streamAppBuildData = useCallback(function() {
        var appSessionId = appSessionIdRef.current;
        isStreamingRef.current = true;
        isOtherStreamingRef.current = false;
        appBuildDataChannel.postMessage({
            event: 1,
            appSessionId: appSessionId
        });
        var remoteMfeMap = window.remoteMfeMap;
        var buildMap = getAppBuildData();
        var _enabledPathListRef_current;
        var enabledPathList = (_enabledPathListRef_current = enabledPathListRef.current) !== null && _enabledPathListRef_current !== void 0 ? _enabledPathListRef_current : [];
        var appBuildList = Object.keys(buildMap).map(function(appKey) {
            if (allMfeTypes.includes(appKey)) {
                var hasEnabledPaths = enabledPathList.some(function(item) {
                    return item.mfeType === appKey;
                });
                var _remoteMfeMap_appKey, _buildMap_appKey;
                return {
                    appKey: appKey,
                    baseUrl: (_remoteMfeMap_appKey = remoteMfeMap[appKey]) !== null && _remoteMfeMap_appKey !== void 0 ? _remoteMfeMap_appKey : '',
                    currentBuildId: hasEnabledPaths ? (_buildMap_appKey = buildMap[appKey]) !== null && _buildMap_appKey !== void 0 ? _buildMap_appKey : null : null
                };
            }
            var _buildMap_appKey1;
            return {
                appKey: appKey,
                baseUrl: window.location.origin,
                currentBuildId: (_buildMap_appKey1 = buildMap[appKey]) !== null && _buildMap_appKey1 !== void 0 ? _buildMap_appKey1 : null
            };
        }).filter(function(item, index, itemList) {
            return !!item.baseUrl && !!item.currentBuildId && itemList.findIndex(function(innerItem) {
                return innerItem.baseUrl === item.baseUrl;
            }) === index;
        });
        var requestList = appBuildList.map(function(param) {
            var appKey = param.appKey, baseUrl = param.baseUrl, currentBuildId = param.currentBuildId;
            return appService.getAppVersion(baseUrl).pipe(map(function(buildId) {
                return {
                    appKey: appKey,
                    buildId: buildId,
                    currentBuildId: currentBuildId
                };
            }), catchError(function() {
                trackCallError(appKey);
                return of({
                    appKey: appKey,
                    buildId: null,
                    currentBuildId: currentBuildId
                });
            }));
        });
        deltaStreamRef.current = interval(intervalTime).pipe(switchMap(function() {
            return forkJoin(requestList);
        })).subscribe({
            next: function(buildDataList) {
                if (!isReloadRequired && buildDataList.some(function(data) {
                    return data.buildId && data.buildId !== data.currentBuildId;
                })) {
                    setIsReloadRequired(true);
                }
                appBuildDataChannel.postMessage({
                    event: 4,
                    appSessionId: appSessionIdRef.current,
                    buildDataList: buildDataList
                });
            }
        });
    }, [
        isReloadRequired,
        trackCallError
    ]);
    useEffect(function() {
        var timer = setTimeout(function() {
            var isDifferent = false;
            if (isStreamingRef.current) {
                var _enabledPathListRef_current;
                var pathList = (_enabledPathListRef_current = enabledPathListRef.current) !== null && _enabledPathListRef_current !== void 0 ? _enabledPathListRef_current : [];
                isDifferent = mfeEnabledPaths.length === pathList.length ? !mfeEnabledPaths.every(function(a1) {
                    return pathList.some(function(b1) {
                        return b1.path === a1.path;
                    });
                }) : true;
            }
            enabledPathListRef.current = mfeEnabledPaths;
            if (!isStreamingRef.current && !isOtherStreamingRef.current || isDifferent) {
                streamAppBuildData();
            }
        }, 1000);
        return function() {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        mfeEnabledPaths,
        streamAppBuildData
    ]);
    useEffect(function() {
        var appSessionId = appSessionIdRef.current;
        appBuildDataChannel.postMessage({
            event: 0,
            appSessionId: appSessionId
        });
        appBuildDataChannel.addEventListener('message', function(param) {
            var data = param.data;
            if (data.appSessionId && data.appSessionId !== appSessionId) {
                if (data.event === 0 && isStreamingRef.current) {
                    appBuildDataChannel.postMessage({
                        event: 1,
                        appSessionId: appSessionId
                    });
                    var _joinedStreamListRef_current;
                    joinedStreamListRef.current = _to_consumable_array((_joinedStreamListRef_current = joinedStreamListRef.current) !== null && _joinedStreamListRef_current !== void 0 ? _joinedStreamListRef_current : []).concat([
                        data.appSessionId
                    ]);
                } else if (data.event === 1) {
                    isOtherStreamingRef.current = true;
                } else if (data.event === 2 && data.targetSessionId === appSessionId) {
                    streamAppBuildData();
                    var _data_sharedJoinedStreamList;
                    joinedStreamListRef.current = (_data_sharedJoinedStreamList = data.sharedJoinedStreamList) !== null && _data_sharedJoinedStreamList !== void 0 ? _data_sharedJoinedStreamList : [];
                } else if (data.event === 3) {
                    var _joinedStreamListRef_current1;
                    joinedStreamListRef.current = ((_joinedStreamListRef_current1 = joinedStreamListRef.current) !== null && _joinedStreamListRef_current1 !== void 0 ? _joinedStreamListRef_current1 : []).filter(function(item) {
                        return item !== data.appSessionId;
                    });
                } else if (data.event === 4) {
                    handleNewBuildEvent(data.buildDataList);
                }
            }
        });
    // eslint-disable-next-line react-hooks-configurable/exhaustive-deps
    }, []);
    useEffect(function() {
        var handleBeforeUnload = function() {
            var appSessionId = appSessionIdRef.current;
            if (isStreamingRef.current) {
                var _joinedStreamListRef_current;
                var joinedStreamList = (_joinedStreamListRef_current = joinedStreamListRef.current) !== null && _joinedStreamListRef_current !== void 0 ? _joinedStreamListRef_current : [];
                if (joinedStreamList.length) {
                    var targetSessionId = joinedStreamList[0];
                    var sharedJoinedStreamList = joinedStreamList.filter(function(item) {
                        return item !== targetSessionId;
                    });
                    appBuildDataChannel.postMessage({
                        event: 2,
                        targetSessionId: joinedStreamList[0],
                        sharedJoinedStreamList: sharedJoinedStreamList,
                        appSessionId: appSessionId
                    });
                }
            } else {
                appBuildDataChannel.postMessage({
                    event: 3,
                    appSessionId: appSessionId
                });
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function() {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    return {
        isReloadRequired: isReloadRequired
    };
};
